import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import Constants from 'src/app/pages/checkout/utils/Constants';

@Component({
  selector: 'travel-ui-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  @Input() policies: any;
  @Input() cancellationPolicies: any;
  @Input() includes?: string[];
  @Input()
  excludes: any[] = [];
  @Input() generalPolicies: any;
  

  @Input() isBookingPolicy = false;
  @Input()
  policyHtml!: string;

  @Output() onClose: EventEmitter<any> = new EventEmitter();

cancellationFlag : boolean = false; 

  constructor() { }

  ngOnInit() {
    this.cancellationPolicies?.map((policy: { rules: any[]; }) => {
      var multiplePolicies = policy.rules.length > 1;
      return policy?.rules?.map(rule => {
        rule.startDate = moment.parseZone(rule.start).format(Constants.dateFormat);
        rule.endDate = moment.parseZone(rule.end).format(Constants.dateFormat);

        if( !this.cancellationFlag && multiplePolicies &&  rule.valueType === 'Percentage' && rule.value === 100 ){
          this.cancellationFlag = true;
        }
      });
    });
  }

  onClickClose() {
    this.onClose.emit();
  }

}
